import { render, staticRenderFns } from "./CommandeList.vue?vue&type=template&id=bb17274c&"
import script from "./CommandeList.vue?vue&type=script&lang=js&"
export * from "./CommandeList.vue?vue&type=script&lang=js&"
import style0 from "./CommandeList.vue?vue&type=style&index=0&id=bb17274c&prod&lang=css&"
import style1 from "./CommandeList.vue?vue&type=style&index=1&id=bb17274c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports